import { ChevronRight } from 'lucide-react';
import { Link } from 'react-router-dom';
import type { CaptureJob } from '@/lib/api/types';
import { captureCount, captureCountLabel, firstLine } from './job-text';

/**
 * One job on My jobs: its name, the first line of what the manager asked
 * for, and how many captures it holds. The whole card is the link, because
 * an operator in gloves aims for the card, not for the words on it.
 */
export function JobCard({ job }: { job: CaptureJob }) {
  const lead = firstLine(job.instructions);
  return (
    <Link
      to={`/jobs/${encodeURIComponent(job.jobId)}`}
      className="flex min-h-20 items-center gap-3 rounded-card border border-border p-4 transition-colors hover:border-border-strong hover:bg-white/5 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-accent sm:p-5"
    >
      <div className="min-w-0 flex-1">
        <h2 className="text-base font-medium text-surface-foreground">{job.name}</h2>
        {lead && <p className="mt-1 truncate text-sm text-muted">{lead}</p>}
        <p className="mt-2 text-xs text-muted">{captureCountLabel(captureCount(job))}</p>
      </div>
      <ChevronRight className="size-5 shrink-0 text-muted" aria-hidden="true" />
    </Link>
  );
}
